import { render } from "./InfographWindow.vue?vue&type=template&id=4a43085b&scoped=true"
import script from "./InfographWindow.vue?vue&type=script&lang=js"
export * from "./InfographWindow.vue?vue&type=script&lang=js"

import "./InfographWindow.vue?vue&type=style&index=0&id=4a43085b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a43085b"

export default script